import { render, staticRenderFns } from "./RankingProcessors.vue?vue&type=template&id=0ea2eb90&scoped=true&"
import script from "./RankingProcessors.vue?vue&type=script&lang=js&"
export * from "./RankingProcessors.vue?vue&type=script&lang=js&"
import style0 from "./RankingProcessors.vue?vue&type=style&index=0&id=0ea2eb90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea2eb90",
  null
  
)

export default component.exports